import { render } from "./maxiMaize.vue?vue&type=template&id=6eddef7a"
import script from "./maxiMaize.vue?vue&type=script&lang=js"
export * from "./maxiMaize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__